/**
 * navigation/navigationRef.ts
 * Container-level navigation ref passed to the single NavigationContainer in
 * App.tsx. The authenticated shell uses its own in-shell router (shellNav), so
 * this ref only needs to exist for the container — it isn't strongly typed to a
 * specific param list.
 */

import { createNavigationContainerRef } from '@react-navigation/native';

export const navigationRef = createNavigationContainerRef();
